module.exports = __webpack_public_path__ + "img/onboarding-modal-image-02.a22a1c3.svg";